"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var OpenApplication = function OpenApplication(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 22 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 21 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Open Application' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Open Application' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 22 21"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access_PAP's",
    transform: "translate(-1185.000000, -543.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Open-Application",
    transform: "translate(1185.000000, 540.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.8135049,7.79062184 C23.2197143,7.79062184 23.5490121,8.11821836 23.5490121,8.52232916 C23.5490121,8.92643995 23.2197143,9.25403647 22.8135049,9.25403647 L11.9859686,9.25403647 L15.0505822,12.302817 C15.3349288,12.5924297 15.3294405,13.0565248 15.0383237,13.3394023 C14.7472069,13.6222799 14.2807017,13.6168199 13.9963551,13.3272072 L9.70589619,9.03452428 C9.42556284,8.75000464 9.42556284,8.29465368 9.70589619,8.01013403 L13.9963551,3.71745111 C14.2807017,3.42783838 14.747207,3.42237845 15.0383237,3.705256 C15.3294405,3.98813355 15.3349288,4.45222861 15.0505822,4.74184135 L11.9859686,7.79062184 L22.8135049,7.79062184 Z",
    id: "Shape-Copy-2",
    transform: "translate(16.522329, 8.522329) rotate(-225.000000) translate(-16.522329, -8.522329) "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.0161133,4.25 C11.4303268,4.25 11.7661133,4.58578644 11.7661133,5 C11.7661133,5.41421356 11.4303268,5.75 11.0161133,5.75 L4.1143983,5.74983534 C2.44764249,5.78476678 1.75,6.45865247 1.75,7.99316406 L1.74977354,19.9808384 C1.79226468,21.7095508 2.50141914,22.4397034 4.09868345,22.4397034 L16.1938983,22.4397034 C17.6971742,22.4397034 18.3451536,21.7271047 18.3450213,19.9992676 L18.3450213,14.0948517 C18.3450213,13.6806381 18.6808078,13.3448517 19.0950213,13.3448517 C19.5092349,13.3448517 19.8450213,13.6806381 19.8450213,14.0948517 L19.8450213,19.9992102 C19.8452146,22.5253449 18.5591119,23.9397034 16.1938983,23.9397034 L4.09868345,23.9397034 C1.66892952,23.9397034 0.312295023,22.5428988 0.25,19.9992676 L0.25,7.99316406 C0.25,5.62337878 1.61814648,4.30182176 4.09868345,4.25 L11.0161133,4.25 Z",
    id: "Path-2-Copy-2"
  })))));
};
OpenApplication.propTypes = _index.iconProps;
var _default = OpenApplication;
exports["default"] = _default;